"use client";

import { RoleIcon, useRoleLabel } from "@/shared/ui/data-display/role-icon";

/**
 * Выбор роли плиткой: иконка позиции + русское название, все варианты видны сразу.
 *
 * KAN-368: раньше в модалке заявки роль выбиралась через `Select`, и внутрь его
 * пунктов был вложен `RoleCell` — ячейка ТАБЛИЦЫ состава: бокс 40×40 и подпись в
 * две строки. В строке-триггере высотой 36px это не помещалось (иконка вылезала
 * за рамку), триггер с `w-fit` оказывался уже раскрытого списка, а шесть пунктов
 * по ~56px перекрывали кнопки «Отмена» и «Подать заявку».
 *
 * Плитка снимает всё это разом: списка нет — нечему перекрывать и не с чем
 * расходиться по ширине. Тот же элемент уже используется при смене роли игрока
 * (`roster-members-table.tsx`), так что выбор роли теперь выглядит одинаково
 * везде.
 */
export function RolePicker({
  roles,
  value,
  onChange,
  disabled = false,
  idPrefix = "role",
}: {
  roles: string[];
  value: string;
  onChange: (role: string) => void;
  disabled?: boolean;
  /** Для связи с `<Label htmlFor>`: id получает первая плитка. */
  idPrefix?: string;
}) {
  const roleLabel = useRoleLabel();
  return (
    <div className="r-roleseg r-roleseg--auto" role="radiogroup">
      {roles.map((role, i) => {
        const label = roleLabel(role);
        const selected = value === role;
        return (
          <button
            key={role}
            id={i === 0 ? idPrefix : undefined}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`r-roleseg__b${selected ? " is-on" : ""}`}
            title={label}
            disabled={disabled}
            onClick={() => onChange(role)}
          >
            <RoleIcon role={role} size={18} />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
